import React, { type ReactNode } from 'react';
import { useAuth } from './useAuth';
import { StatusDashboardOverviewProvider } from './useStatusDashboardOverview';
import { SystemAlertsProvider } from './SystemAlertsProvider';

interface AuthenticatedSystemProvidersProps {
  children: ReactNode;
}

/**
 * Providers de alertas e overview do status — montados uma vez após login
 * para não recarregar ao trocar de tela.
 */
export const AuthenticatedSystemProviders: React.FC<AuthenticatedSystemProvidersProps> = ({
  children,
}) => {
  const { token, hasAccess } = useAuth();

  if (!token || !hasAccess) {
    return <>{children}</>;
  }

  return (
    <StatusDashboardOverviewProvider>
      <SystemAlertsProvider>
        {children}
      </SystemAlertsProvider>
    </StatusDashboardOverviewProvider>
  );
};
